const LogoWithText = () => {
    return (
        <img
            src="/logos/ironpipeline-dark.png"
            alt="Iron Pipeline Logo"
            className="w-full h-auto"
        />
    )
}

export default LogoWithText